import { Core } from "@faire/design-tokens";
import { pageMaxWidthCss } from "@faire/help-center/components/Mixin";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";
import { FaireIntro } from "./FaireIntro";
import { FaireLinks } from "./FaireLinks";
import { PolicyLinks } from "./PolicyLinks";
export var Footer = function Footer() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FullWidthBorderedWrapper, null, /*#__PURE__*/React.createElement(MainContentWrapper, null, /*#__PURE__*/React.createElement(FaireIntro, null), /*#__PURE__*/React.createElement(FaireLinks, null))), /*#__PURE__*/React.createElement(FullWidthBorderedWrapper, null, /*#__PURE__*/React.createElement(PolicyLinks, null)));
};
var FullWidthBorderedWrapper = styled.div.withConfig({
  displayName: "Footer__FullWidthBorderedWrapper"
})(["", "{border-top:1px solid ", ";}"], responsiveMediaQueries.tabletAndAbove, Core.border.muted);
var MainContentWrapper = styled.div.withConfig({
  displayName: "Footer__MainContentWrapper"
})(["display:flex;flex-direction:column;padding:", ";", "{flex-direction:row;padding:", ";}", "{padding:", ";}", ""], getSpacing("3x"), responsiveMediaQueries.tabletAndAbove, getSpacing("5x"), responsiveMediaQueries.desktopAndAbove, getSpacing("5x", "7x"), pageMaxWidthCss);